import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {deleteSupplier, hideDeleteSupplierModal} from "./actions";
import DeleteFormModal from "../common/DeleteFormModal";

const DeleteSupplierModal = ({
                              onDelete,
                              supplier,
                              supplierDeleting,
                              hideDeleteSupplierModal,
                              deleteSupplier,
                              visible
                            }) => {
  const supplierHandle = {supplierId: supplier.supplierId};
  return (
    <DeleteFormModal entityType="Supplier" entityName={supplier.name} entityHandle={supplierHandle} visible={visible}
                     entityDeleting={supplierDeleting} deleteEntity={deleteSupplier}
                     hideDeleteFormModal={hideDeleteSupplierModal} onDelete={onDelete}/>);
};

DeleteSupplierModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  /* state */
  visible: PropTypes.bool.isRequired,
  supplier: PropTypes.object,
  supplierDeleting: PropTypes.bool.isRequired,
  /* actions */
  hideDeleteSupplierModal: PropTypes.func.isRequired,
  deleteSupplier: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  visible: state.supplier.deleteSupplierModalVisible,
  supplier: state.supplier.supplierToDelete,
  supplierDeleting: state.supplier.supplierDeleting,
});

const mapDispatchToProps = dispatch => ({
  hideDeleteSupplierModal: bindActionCreators(hideDeleteSupplierModal, dispatch),
  deleteSupplier: bindActionCreators(deleteSupplier, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSupplierModal);



// WEBPACK FOOTER //
// ./src/Supplier/DeleteSupplierFormModal.js